/**
 * DeliveryDriverStatus
 * @author ftgibran
 */

export enum DeliveryDriverStatus {
  WITH_DRIVER = 1,
  WITHOUT_DRIVER = 2,
}
